export const TEMPLATE_HEADERS = ['DSP Name', '费用类型', '金额'] as const;
export const TEMPLATE_FILE_NAME = 'DSP保证金/保险模板.xlsx';
export const DEPOSIT_INSURANCE_AUDIT_BIZ_TYPE = 'deposit_insurance_upload_audit';

const fmtUtcDate = (d: Date) =>
  `${d.getUTCFullYear()}/${String(d.getUTCMonth() + 1).padStart(2, '0')}/${String(d.getUTCDate()).padStart(2, '0')}`;

/**
 * 计算上一周和上上周的账期（周一 00:00:00 UTC ~ 周日 23:59:59 UTC，不带毫秒避免 MySQL 进位）。
 * 逻辑复制自 QcPenaltyUploadPage.getWeekPeriods，增加 now 参数便于测试。
 */
export function getWeekPeriods(now: Date = new Date()): { label: string; periodStart: string; periodEnd: string }[] {
  const dayOfWeek = now.getUTCDay();
  const diffToMonday = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
  const oneWeekMs = 7 * 24 * 60 * 60 * 1000;

  const thisMonday = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() + diffToMonday));
  const thisSunday = new Date(
    Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() + diffToMonday + 6, 23, 59, 59, 0),
  );

  const lastMonday = new Date(thisMonday.getTime() - oneWeekMs);
  const lastSunday = new Date(thisSunday.getTime() - oneWeekMs);
  const prevMonday = new Date(thisMonday.getTime() - 2 * oneWeekMs);
  const prevSunday = new Date(thisSunday.getTime() - 2 * oneWeekMs);

  return [
    {
      label: `${fmtUtcDate(lastMonday)} ~ ${fmtUtcDate(lastSunday)} (上周)`,
      periodStart: lastMonday.toISOString(),
      periodEnd: lastSunday.toISOString(),
    },
    {
      label: `${fmtUtcDate(prevMonday)} ~ ${fmtUtcDate(prevSunday)} (上上周)`,
      periodStart: prevMonday.toISOString(),
      periodEnd: prevSunday.toISOString(),
    },
  ];
}

export function buildTemplateSheet(): (string | number)[][] {
  return [[...TEMPLATE_HEADERS], ['示例DSP', 'Deposit', 100], ['示例DSP', 'Insurance', 50]];
}

const STATUS_LABELS: Record<string, string> = {
  UPLOADED: '已上传',
  PARSING: '解析中',
  VALIDATION_FAILED: '校验失败',
  PENDING_APPROVAL: '待审核',
  APPROVAL_REJECTED: '审核驳回',
  EXECUTING: '入账中',
  SUMMARIZING: '汇总中',
  COMPLETED: '已完成',
};

export function statusLabel(status: string, failureReason?: string | null): string {
  if (status === 'COMPLETED' && failureReason) {
    return '已完成（入账失败）';
  }
  return STATUS_LABELS[status] ?? status;
}

const IN_PROGRESS = new Set(['UPLOADED', 'PARSING', 'PENDING_APPROVAL', 'EXECUTING', 'SUMMARIZING']);

export function isInProgress(status: string): boolean {
  return IN_PROGRESS.has(status);
}
